import dayjs, { Dayjs } from 'dayjs'
import { plural } from '~/utils/filters'

export default function formatDateToNow (dateWithTimezone: string | Date | Dayjs, options?: {
  withSuffix?: boolean
  cutUnit?: boolean
}): string {
  const { withSuffix = false, cutUnit = true } = options || {}
  const suffix = withSuffix ? ' назад' : ''
  const date = typeof dateWithTimezone === 'string' || dateWithTimezone instanceof Date
    ? dayjs(dateWithTimezone)
    : dateWithTimezone
  const currentDate = dayjs()

  // Дата в будущем (битый lenta_date или рассинхрон часов клиента) не должна показываться
  // как «только что» — это маскирует ошибку и ломает хронологию ленты. Небольшой допуск
  // (60 c) на расхождение часов клиента; дальше показываем фактическую дату.
  if (currentDate.diff(date, 'second') < -60) {
    return date.format('DD.MM.YYYY')
  }

  const month = currentDate.diff(date, 'M')
  if (month > 0) {
    return date.format('DD.MM.YYYY')
  }

  const days = currentDate.diff(date, 'd')
  if (days > 0) {
    if (cutUnit) {
      return `${days} д`
    }

    return plural(days, 'день', 'дня', 'дней') + suffix
  }

  const hours = currentDate.diff(date, 'h')
  if (hours > 0) {
    if (cutUnit) {
      return `${hours} ч`
    }

    return plural(hours, 'час', 'часа', 'часов') + suffix
  }

  const minutes = currentDate.diff(date, 'm')
  if (minutes > 0) {
    if (cutUnit) {
      return `${minutes} м`
    }

    return plural(minutes, 'минута', 'минуты', 'минут') + suffix
  }

  const seconds = currentDate.diff(date, 's')
  if (seconds > 0) {
    if (cutUnit) {
      return `${seconds} с`
    }

    return plural(seconds, 'секунда', 'секунды', 'секунд') + suffix
  }

  return 'только что'
}
